import CommentsMappers from "./comment-mappers";

const CommentsHelpers = {
    Mappers: CommentsMappers
};

export default CommentsHelpers;
